// src/components/RBAC/RoleBasedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';

const RoleBasedRoute = ({ 
  permission, 
  children, 
  redirectTo = '/dashboard'
}) => {
  const { hasPermission, loading } = usePermissions();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '16px',
        color: '#94a3b8',
      }}>
        Loading...
      </div>
    );
  }

  const hasRoutePermission = Array.isArray(permission)
    ? permission.some(item => hasPermission(item))
    : hasPermission(permission);

  if (!hasRoutePermission) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleBasedRoute;
